module.exports = __webpack_public_path__ + "static/media/Liste.fa406805.png";